import { useState, type FormEvent } from 'react'
import type { VehicleDTO } from '@wf/shared'
import { VehicleDetailFields, vehicleFieldsToBody, vehicleToFields, type VehicleFieldsBody, type VehicleFieldValues } from './VehicleFields'

/**
 * Fahrzeug-Stammdaten inline bearbeiten: Kennzeichen (Pflicht) + die Fahrzeugschein-Felder (Marke, Modell,
 * FIN, HSN/TSN, Erstzulassung, Motor). Die OCC-`version` gibt der Aufrufer beim Speichern mit (sie steckt im
 * VehicleDTO). Kennzeichen wird getrimmt, leere Optionalfelder werden zu null — kein „leerer String" in der DB.
 */
export function VehicleEditForm({
  vehicle,
  busy,
  error,
  onSave,
  onCancel,
}: {
  vehicle: VehicleDTO
  busy: boolean
  error: string | null
  onSave: (fields: { plate: string } & VehicleFieldsBody) => void
  onCancel: () => void
}) {
  const [plate, setPlate] = useState(vehicle.plate)
  const [fields, setFields] = useState<VehicleFieldValues>(() => vehicleToFields(vehicle))

  function submit(event: FormEvent) {
    event.preventDefault()
    if (!plate.trim()) return
    onSave({ plate: plate.trim(), ...vehicleFieldsToBody(fields) })
  }

  return (
    <form className="wf-card wf-card--static wf-vehicleform" onSubmit={submit}>
      <label className="wf-field">
        <span className="wf-label">Kennzeichen</span>
        <input className="wf-input" aria-label="Kennzeichen" value={plate} onChange={(event) => setPlate(event.target.value)} />
      </label>
      <VehicleDetailFields value={fields} onChange={(patch) => setFields((f) => ({ ...f, ...patch }))} />
      {error ? (
        <p className="error" role="alert">
          {error}
        </p>
      ) : null}
      <div className="wf-listfoot">
        <button type="button" className="wf-btn wf-btn--ghost" disabled={busy} onClick={onCancel}>
          Abbrechen
        </button>
        {/* Eindeutiger Accessible-Name: auf der Kundenseite steht parallel der „Speichern"-Knopf der Stammdaten. */}
        <button type="submit" className="wf-btn" aria-label="Fahrzeug speichern" disabled={busy || !plate.trim()}>
          Speichern
        </button>
      </div>
    </form>
  )
}
